import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { Button, Flex, Input,  Typography } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { gymsAction } from 'src/store/Slices/Administrator/GymsSlice';
import { trainingAction } from 'src/store/Slices/Administrator/TrainingsSlice';
import { UploadOutlined } from '@ant-design/icons';
import { Upload } from 'antd/lib';

const AddEditTrainingModal = ({ visible, setVisible, trainingInfo, setPage, setPageSize }) => {

    const dispatch = useDispatch()

    const [name, setName] = useState()
    const [description, setDescription] = useState()
    const [imgUrl, setImgUrl] = useState()
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false)


    useEffect(() => {
        setName()
        setDescription()
        setImgUrl()
        setFileList([])
    }, [visible.flag])


    useEffect(() => {
        if (visible.flag === 'edit') {
            setName(trainingInfo?.name)
            setDescription(trainingInfo?.description)
            setImgUrl(trainingInfo?.imageUrl?.props?.src)
            setFileList([])
        }
    }, [visible, trainingInfo])

    const onClickSubmit = () => {
        const formData = new FormData();
        fileList.forEach((file) => {
            formData.append('imageFile', file);
        });
        formData.append('id', visible.flag !== 'add' ? trainingInfo.id : undefined)
        formData.append('name', name)
        formData.append('description', description)
        formData.append('imageUrl', imgUrl)
        setUploading(true)
        dispatch(trainingAction({
            flag: visible.flag === 'add' ? 'put' : 'post', value: formData
        })).then(() => {
            dispatch(trainingAction({ flag: 'get' })).then(() => {
                setVisible({ open: false, flag: '' })
                setPage(1)
                setPageSize(20)
                setUploading(false)
            })
        })
    }

    const handleChange = (info) => {
        if (info.fileList.length === 0) {
            setFileList([])
        } else {
            let newFileList = [...fileList];
            newFileList = newFileList.slice(-1);

            setFileList(newFileList);
        }
 
    };

    const props = {
        onRemove: () => {
            setFileList([])
        },
        onChange: handleChange,
        beforeUpload: (file) => {
            if (file.size > 1048576) {
                openNotification({
                    type: 'error',
                    message: 'Размер файла должен быть меньше одного мегабайта'
                })
                return false
            }
            setFileList([...fileList, file]);
            return false;
        },
        fileList,
    };


    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить тип тренировки' : 'Редактировать тип тренировки'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Наименование</Typography.Title>
                            <Input
                                value={name}
                                onChange={e => setName(e.currentTarget.value)}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Описание</Typography.Title>
                            <Input
                                value={description}
                                onChange={e => setDescription(e.currentTarget.value)}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Ссылка на изображение</Typography.Title>
                            <Input
                                value={imgUrl}
                                onChange={e => setImgUrl(e.currentTarget.value)}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Изображение (размер меньше 1 МБ)</Typography.Title>
                            <Upload accept='.png,.jpg,.jpeg' {...props}>
                                <Button icon={<UploadOutlined />}>Выберите файл</Button>
                            </Upload>
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton disabled={uploading} onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditTrainingModal